/*
 *
 * MobileLayout constants
 *
 */
export const FLUSH_STATE = 'app/MobileLayout/FLUSH_STATE';
